import { AsyncPipe, NgIf, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiLetModule } from '@taiga-ui/cdk';
import { TuiButtonModule } from '@taiga-ui/core';
import { TuiMarkerIconModule } from '@taiga-ui/kit';
import { ConvertMetersPipe, Shop } from '@us/web/shared/data-access';
import { RouterUtil } from '@us/web/shared/utils';
import { OpenTimeToDayPipe } from '@us/web/shops/data-access';
import {
    FormatDistanceToNowPipeModule,
    FormatPipeModule,
    IsFuturePipeModule,
    IsTodayPipeModule,
    ParseIsoPipeModule
} from 'ngx-date-fns';

@Component({
    selector: 'us-shop-card',
    standalone: true,
    imports: [
        ConvertMetersPipe,
        IonicModule,
        OpenTimeToDayPipe,
        TuiButtonModule,
        TuiLetModule,
        TuiMarkerIconModule,
        AsyncPipe,
        RouterLink,
        NgIf,
        TranslocoModule,
        NgOptimizedImage,
        FormatDistanceToNowPipeModule,
        ParseIsoPipeModule,
        IsFuturePipeModule,
        IsTodayPipeModule,
        FormatPipeModule
    ],
    templateUrl: './shop-card.component.html',
    styleUrls: ['./shop-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopCardComponent {
    @Input() shop!: Shop;

    protected readonly RouterUtil = RouterUtil;
}
